module.exports = __webpack_public_path__ + "img/icon-tab-mine-active.a9723fa4.png";